import { render, staticRenderFns } from "./Document-type-modal.vue?vue&type=template&id=08754ee0"
import script from "./Document-type-modal.vue?vue&type=script&lang=js"
export * from "./Document-type-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports